import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArchiveDocumentsBoxBig16 } from 'shared/assets/icons';

import { MetaInteraction } from '../meta-interaction';

export type MetaArchiveHabitProps = {
  onArchive: () => void;
};

export const MetaArchiveHabit: React.FC<MetaArchiveHabitProps> = ({
  onArchive,
}) => {
  const { t } = useTranslation();

  return (
    <MetaInteraction
      icon={ArchiveDocumentsBoxBig16}
      label={t('general.labels.archive')}
      placeholder={t('general.labels.archive')}
      onClick={onArchive}
    />
  );
};
